import NotFoundQuotation from './NotFoundQuotationContainer';

export default NotFoundQuotation;
